import { API_PATHS } from "../../config/ApiPaths";

export const apiGetInfoRevenue = (id = "ALL") => {
  return `${API_PATHS.getInfoRevenue}?id=${id}`;
};
